<script>
	import { scrollTo } from '../utils'

	export let more = false
	export let scrollToElement = null

	function toggle() {
		more = !more

		if (!more && scrollToElement) scrollTo(scrollToElement)
	}
</script>

<div class="more-less-container">
	<div class="more-less" on:click={toggle}>
		{#if more}
			Weniger anzeigen
		{:else}
			Mehr anzeigen
		{/if}
	</div>
</div>

<style lang="scss">
	.more-less-container {
		text-align: center;
		margin: 10px 0;
		position: relative;

		&::before {
			content: ' ';
			width: 100%;
			left: 0;
			right: 0;
			height: 1px;
			top: 50%;
			background: #2a2a2a;
			position: absolute;
		}
	}

	.more-less {
		margin: 0 auto;
		background: #2a2a2a;
		font-size: 14px;
		line-height: 14px;
		color: #fff;
		padding: 6px 12px;
		user-select: none;
		cursor: pointer;
		display: inline-block;
		position: relative;
		font-weight: 500;
		border-left: 10px solid #fff;
		border-right: 10px solid #fff;
	}
</style>
